import { inject, observer } from 'mobx-react';
import React from 'react';
import ModelItem from '../../models/ModelItem';
import Store from '../../store';
import { Badge } from 'react-bootstrap';

interface ModelStatusProps {
  store?: Store;
  model: ModelItem;
}

export default inject('store')(
  observer(
    class ModelStatus extends React.Component<ModelStatusProps> {
      render() {
        const { model } = this.props;
        if (model.type === 'customer_fit') {
          if (model.live) {
            if (model.is_primary) {
              return <Badge bg="success">Live as Primary Fit Model</Badge>;
            }
            return <Badge bg="success">Live as Secondary Fit Model</Badge>;
          }
          if (!model.is_primary && model.lastDeployedAt) {
            return <Badge bg="success">Live as Secondary Fit Model</Badge>;
          }
        } else if (model.type === 'mqa' && model.live) {
          // Account-engagement supports a standard (primary) model plus multiple
          // secondaries, so distinguish them the way the fit family does.
          if (model.is_primary) {
            return <Badge bg="success">Live as Primary Model</Badge>;
          }
          return <Badge bg="success">Live as Secondary Model</Badge>;
        } else if (model.live) {
          return <Badge bg="success">Live</Badge>;
        }
        return <Badge bg="secondary">Draft</Badge>;
      }
    }
  )
);
